const MINUTE = 60;
const HOUR = 60 * MINUTE;

export function parseTimestamp(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    const ms = value.getTime();
    return Number.isFinite(ms) ? ms : null;
  }
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return null;
    return value < 1e12 ? value * 1000 : value;
  }
  const trimmed = String(value).trim();
  if (/^\d+$/.test(trimmed)) {
    const numeric = Number(trimmed);
    if (!Number.isFinite(numeric)) return null;
    return numeric < 1e12 ? numeric * 1000 : numeric;
  }
  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : null;
}

// Sem handling_started_at não dá para saber quando o ciclo atual começou: em
// conversa anterior à feature, created_at pode incluir vários atendimentos já
// resolvidos e o chip mostraria centenas de horas. Melhor não afirmar nada — o
// valor nasce sozinho no próximo resolve/reabertura.
export function resolveHandlingStartedAt(conversation) {
  return conversation?.handling_started_at || null;
}

export function elapsedSeconds(startedAt, now = Date.now()) {
  const start = parseTimestamp(startedAt);
  if (start == null) return 0;
  return Math.max(0, Math.floor((now - start) / 1000));
}

export function formatElapsed(seconds) {
  const safe = Math.max(0, Math.floor(Number(seconds) || 0));
  const totalMinutes = Math.floor(safe / MINUTE);
  if (totalMinutes < 60) return `${totalMinutes} min`;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h ${String(minutes).padStart(2, '0')}min`;
}

export function timerTone(seconds) {
  const minutes = Math.max(0, Number(seconds) || 0) / MINUTE;
  if (minutes < 15) return 'teal';
  if (minutes <= 60) return 'amber';
  return 'ruby';
}

export function timerToneClasses(tone) {
  if (tone === 'amber') return 'bg-n-amber-9/20 text-n-amber-11';
  if (tone === 'ruby') return 'bg-n-ruby-9/15 text-n-ruby-11';
  return 'bg-n-teal-9/15 text-n-teal-11';
}

export function formatDurationLabel(seconds) {
  return formatElapsed(seconds);
}

export { MINUTE, HOUR };
